import { useAuthInit } from "@/services/auth";

import Router from "./router.component";

const RouterWrapper = () => {
  const { isUserSessionLoaded } = useAuthInit();

  if (!isUserSessionLoaded) return null;

  return <Router />;
};

export default RouterWrapper;
